import { render, staticRenderFns } from "./EditRegionPage.vue?vue&type=template&id=7b33c932&"
import script from "./EditRegionPage.vue?vue&type=script&lang=js&"
export * from "./EditRegionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports